exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.floating-button{\n    background: #1b1b1b;\n    border-radius: 50%;\n    padding: 15px 20px;\n    color: #fff;\n    position: fixed;\n    bottom: 15px;\n    right: 10px;\n    z-index: 10;\n}\n", ""]);

// exports
